(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ph-bf-signup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('phbf-launch-clock')) {
  class PhbfLaunchClock extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-bf-launch]');
      this.deadline = Date.parse(this.root.dataset.deadline);
      if (!Number.isFinite(this.deadline)) return;
      this.update();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    update() {
      const remaining = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
      const values = {days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60};
      Object.entries(values).forEach(([unit, value]) => { this.root.querySelector('[data-bf-unit="' + unit + '"]').textContent = String(value).padStart(2, '0'); });
      this.root.querySelector('[data-bf-digits]').hidden = false;
      if (remaining === 0) { this.root.querySelector('[data-bf-status]').textContent = this.root.dataset.ended; clearInterval(this.interval); }
    }
  }
  customElements.define('phbf-launch-clock', PhbfLaunchClock);
}
function mountBlackFridayClocks(root) {
  root.querySelectorAll('[data-bf-launch]').forEach(section => { if (!section.querySelector('phbf-launch-clock')) section.appendChild(document.createElement('phbf-launch-clock')); });
}
mountBlackFridayClocks(document);
document.addEventListener('shopify:section:load', event => mountBlackFridayClocks(event.target));

  } catch(e) { console.error(e); }
})();
})();
